/**
 * Filters undefined, null or empty strings as well as boolean false from a list of comma separated items, joins them and returns a string
 * Returns null if 'classes' is empty
 * @param {object} classes - An arguments object
 */
export const setClassNames = (...classes) => {
	return [...classes].filter(className => className).join(' ') || null;
};

export function formatLocationData(
	requestDataAccoundId,
	vehicleAccountId,
	vehicleStatus
) {
	// logic to determine what vehicle status should be
	let status = 'ON_LOT';
	let accountId = requestDataAccoundId;

	if (vehicleStatus.toUpperCase() === 'IN_TRANSIT') {
		status = 'IN_TRANSIT';
	} else if (vehicleStatus.toUpperCase() === 'ON_DEPOSIT') {
		status = 'RESERVED';
	} else if (vehicleStatus.toUpperCase() === 'IN_TRANSIT_AT_PORT') {
		status = 'IN_TRANSIT_AT_PORT';
	} else if (vehicleStatus.toUpperCase() === 'IN_TRANSIT_AT_FACTORY') {
		status = 'IN_TRANSIT_AT_FACTORY';
	} else if (requestDataAccoundId !== vehicleAccountId) {
		status = 'OFF_LOT';
		accountId = vehicleAccountId;
	}

	const locationObj = {
		status,
		accountId,
		name: '',
		address: {
			address1: '',
			address2: '',
			address3: '',
			city: '',
			state: '',
			zipcode: '',
			country: ''
		},
		coordinates: {
			lat: '0',
			lon: '0'
		}
	};
	return locationObj;
}

/**
 * Receives link prop
 * returns object of link properties to render in widget
 * @param label
 * @param labels
 * @param sitemap
 * @param widgetInfo
 */

const getLink = (
	linkOpt,
	labels,
	sitemap,
	{ vehicleId, vehicleCategory, pageAlias, vehicleAccountId }
) => {
	const defaultLinkObj = {
		displayLink: true,
		linkLabel: '',
		linkClass: 'dialog',
		dataWidth: null,
		href: null,
		dataHref: null,
		dataTitle: null,
		relData: null
	};

	switch (linkOpt) {
		case 'HOURS_AND_DIRECTIONS':
			return {
				...defaultLinkObj,
				linkLabel: labels.get('LOCATION_DETAILS'),
				dataWidth: 700,
				href: `${sitemap.get(
					'HOURS_DIRECTIONS_FRAGMENT'
				)}?selectedAccountId=${vehicleAccountId}`,
				dataHref: `${sitemap.get(
					'HOURS_DIRECTIONS_FRAGMENT'
				)}?selectedAccountId=${vehicleAccountId}`,
				dataTitle: labels.get('LOCATION_DETAILS')
			};

		case 'CONTACT_US_FOR_DETAILS':
			return {
				...defaultLinkObj,
				linkLabel: labels.get('CONTACT_US_FOR_DETAILS'),
				dataWidth: 375,
				href: `${sitemap.get(
					'INVENTORY_LEAD_DEFAULT'
				)}?itemId=${vehicleId}&category=${vehicleCategory}&parentPageAlias=${pageAlias}`,
				dataHref: `${sitemap.get(
					'INVENTORY_LEAD_DEFAULT'
				)}?itemId=|itemId|&category=|category|&parentPageAlias=${pageAlias}`,
				dataTitle: labels.get('REQUEST_MORE_INFO'),
				relData: 'nofollow'
			};

		default:
			return {
				...defaultLinkObj,
				displayLink: false
			};
	}
};

/**
 * Receives location prop
 * returns object of location properties to render in widget
 * @param status
 * @param propLocation
 * @param labels
 */

const getStatus = (status, { name }, labels) => {
	const defaultStatusObj = {
		icon: 'map',
		vehicleStatusDisplay: labels.get('ON_THE_LOT'),
		location: `${labels.get('AT')} ${name}`,
		displayStatusClass: '',
		displayStatusElement: 'strong',
		locationElement: ''
	};
	switch (status) {
		case 'IN_TRANSIT':
			return {
				...defaultStatusObj,
				icon: 'in-transit',
				vehicleStatusDisplay: labels.get('IN_TRANSIT'),
				location: `${labels.get('TO')} ${name}`
			};

		case 'RESERVED':
			return {
				...defaultStatusObj,
				icon: 'lock',
				vehicleStatusDisplay: labels.get('OSIRIS_RESERVED'),
				displayStatusClass: 'text-danger'
			};

		case 'OFF_LOT':
			return {
				...defaultStatusObj,
				icon: 'off-lot',
				vehicleStatusDisplay: labels.get('LOCATED_AT'),
				location: name,
				displayStatusElement: '',
				locationElement: 'strong'
			};

		case 'IN_TRANSIT_AT_PORT':
			return {
				...defaultStatusObj,
				icon: 'in-transit',
				vehicleStatusDisplay: labels.get('IN_TRANSIT_FROM_PORT'),
				location: `${labels.get('TO')} ${name}`
			};

		case 'IN_TRANSIT_AT_FACTORY':
			return {
				...defaultStatusObj,
				icon: 'in-transit',
				vehicleStatusDisplay: labels.get('IN_TRANSIT_FROM_FACTORY'),
				location: `${labels.get('TO')} ${name}`
			};

		default:
			return defaultStatusObj;
	}
};

/**
 * Receives location prop
 * returns object of text properties to render in widget
 * @param propLocation
 * @param linkOpt
 * @param labels
 * @param sitemap
 * @param overrideLocation
 * @param widgetInfo
 */
export function getLocationAttributes(
	propLocation,
	linkOpt,
	labels,
	sitemap,
	overrideLocation,
	widgetInfo,
	isLocationPopup
) {
	const { deviceType } = widgetInfo;
	const { status: locationStatus } = propLocation;

	let status = '';
	if (locationStatus) {
		if (
			overrideLocation === 'true' &&
			locationStatus.toUpperCase() === 'OFF_LOT'
		) {
			status = 'ON_LOT';
		} else {
			status = locationStatus;
		}
	}

	const linkObj = getLink(
		linkOpt,
		labels,
		sitemap,
		widgetInfo,
		isLocationPopup
	);
	const statusObj = getStatus(status.toUpperCase(), propLocation, labels);

	return {
		...statusObj,
		...linkObj,
		isMobile: deviceType !== 'DESKTOP'
	};
}

/**
 * Create formatted search request object
 * @param {string} vehicleId
 * @returns {object} - Formatted search request object
 */
export const getSearchRO = vehicleId => ({
	vehicle: {
		uuid: vehicleId,
		select: ['category', 'status']
	}
});

export const getSiteAccountId = requestData =>
	(requestData.parameterMap && requestData.parameterMap.accountId) ||
	requestData.accountId;



// WEBPACK FOOTER //
// ./src/utils/utility.js